import { FunctionComponent, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { OrganisationContext } from '../../context';
import { Select, useIsNarrowViewport } from '../../shared';
import { Footer } from '../Footer';
import { MenuOrganisation } from '../MenuOrganisation';

import classNames from 'classnames';
import classes from './SidebarOrganisation.module.scss';

export const SidebarOrganisation: FunctionComponent = () => {
  const { t } = useTranslation();

  const isNarrowViewport = useIsNarrowViewport();

  const { id: orgId, name: orgName } = useContext(OrganisationContext).organisation;

  return (
    <div
      className={classNames(classes['sidebar'], {
        [classes['sidebar--narrow']]: isNarrowViewport,
      })}
    >
      <Select
        label={t('common.organisation')}
        selectedItemId={orgId}
        items={[{ id: orgId, title: orgName }]}
        noSidePadding
        disabled
        noBorder
      />

      <nav>
        <MenuOrganisation />
      </nav>

      <Footer />
    </div>
  );
};
